import { ResolvedTheme, ThemePreference } from 'types';
import { createSlice, createAction, PrepareAction } from '@reduxjs/toolkit';
import {
  persistThemePreference,
  readThemePreference,
  resolveThemePreference,
} from 'services/themePreference.service';

interface ThemeState {
  preference: ThemePreference;
  resolvedTheme: ResolvedTheme;
}

export const defaultThemePreference = readThemePreference();

const initialState: ThemeState = {
  preference: defaultThemePreference,
  resolvedTheme: resolveThemePreference(defaultThemePreference),
};

export const setThemePreference = createAction<PrepareAction<ThemePreference>>(
  'theme/setPreference',
  (preference: ThemePreference) => {
    persistThemePreference(preference);
    return {
      payload: preference,
    };
  }
);

export const setResolvedTheme = createAction<ResolvedTheme>(
  'theme/setResolvedTheme'
);

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setThemePreference, (state, action) => {
      state.preference = action.payload;
      if (action.payload !== 'system') {
        state.resolvedTheme = action.payload;
      }
    });
    builder.addCase(setResolvedTheme, (state, action) => {
      state.resolvedTheme = action.payload;
    });
  },
});

export default themeSlice.reducer;
